import { Box, Typography } from "@mui/material";
import { weekdays } from "../../Helpers/WeekdayList";
import { ColorScheme } from "../../Themes/ColorScheme";

/**
 * Improved version of the selectWeekday component.
 * A component that still renders a selectable list of weekdays.
 * @param {Object} props - The component props.
 * @param {Array} props.days - The selected days, either an array of weekdays or a single string of weekday.
 * @param {Function} props.weekdayClicked - The function to call when a weekday is clicked.
 * @param {Boolean} props.singleSelect - Whether only one day can be selected at a time. If true props.days has to be a string.
 * @returns {JSX.Element} - The WeekdaySelect component.
 */

export const WeekdaySelect = ({ days, weekdayClicked, singleSelect }) => (
	<Box
		sx={{
			flexDirection: "row",
			display: "flex",
			alignItems: "center",
			width: "100%",
			justifyContent: "space-between",
			borderRadius: 5,
			backgroundColor: ColorScheme.lightGrey,
			overflow: "hidden",
		}}
	>
		{weekdays().map(({ short, weekday }) => {
			const isSelected = () =>
				days === null
					? null
					: singleSelect
						? days === weekday
						: days?.some((d) => Number(d) === weekday);

			return (
				<Box
					key={weekday}
					onClick={() => weekdayClicked(weekday)}
					sx={{
						height: 40,
						width: "14.28%",
						overflow: "hidden",
						backgroundColor: isSelected()
							? ColorScheme.primary
							: "",
						transition: "background-color 0.3s",
						alignItems: "center",
						justifyContent: "center",
						display: "flex",
						opacity: singleSelect && !isSelected() ? 0.5 : 1,
						cursor: "pointer",
						pointerEvents: "auto",
					}}
				>
					<Typography
						sx={{
							fontSize: "16px",
							fontWeight: "700",
							color: isSelected()
								? ColorScheme.textPrimary
								: ColorScheme.darkGrey
						}}
					>
						{short}
					</Typography>
				</Box>
			);
		})}
	</Box>
);
